import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import { CloseRounded } from '@mui/icons-material';

export default function NoticeSnackbar({ open, message, onClose }: { open: boolean, message: string, onClose: () => void }) {

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={onClose}
      >
        <CloseRounded fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <Snackbar
      open={open}
      autoHideDuration={2500}
      onClose={onClose}
      message={message}
      action={action}
    />
  );
}
